import { useState } from "react";
import back5 from "../../../../imgs/back5.png";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import Main from "./main";
import Nav from "../../vendor/navbar";
import AddTierModal from "./addTierModal";
import ErrorModal from "../../../Merchant/Modals/errorModal";
import SuccessModal from "../../../modals/successModal";
const Mid = () => {
  const tiernumber=localStorage.getItem("tier")
  const editProduct = useSelector((state) => state.editProduct);
  console.log(editProduct);
  const router = useNavigate();
  const user = useSelector((state) => state.user);
  const [showAddTier, setShowAddTier] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [err, setErr] = useState("");
  const [refetch, setRefetch] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    if (!test) {
      setTest(true);
    } else {
      setTest(false);
    }
  }, []);
  const [test, setTest] = useState(false);
  return (
    <>
      <div className="bg-[#D9EFED] min-h-screen">
        <Nav />
        <div
          className={`${
            user === "vendor-owner"
              ? "flex items-center justify-center bg-[#D9EFED]"
              : "flex items-center justify-center"
          }`}
        >
          <div className="md:w-[95%] mt-[1rem] rounded-md w-[95%] sm:px-20 px-4">
            <div className="cursor-pointer flex w-full items-center justify-center">
              <img
                onClick={() => router("/Inventory-AddProduct")}
                className="sm:w-[1.7rem] w-[1.3rem]"
                src={back5}
                alt=""
              />
              <h2 className="font-bold w-full sm:text-[1.8rem] sm:ml-2 ml-[1rem] text-[1.4rem]">
                Tier Pricing
              </h2>
            </div>
            <div className="flex justify-end mt-4 gap-3">
              <button
                type="button"
                onClick={() => {
                  router("/Inventory");
                }}
                className={`${
                  editProduct
                    ? "hidden"
                    : "cursor-pointer rounded-md pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-red-600 w-[11rem]"
                }`}
              >
                {
                  tiernumber === "1" ? "Next":"Skip"
                }
              </button>
              <button
                type="button"
                onClick={() => {
                  setShowAddTier(true);
                }}
                className="cursor-pointer rounded-md pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-primary w-[11rem]"
              >
                Add New Price
              </button>
            </div>
            <h4 className="text-gray-700 mb-2 font-medium sm:mt-0 mt-5">
              Set custom price tiers for different buyers based on volume,
              loyalty or other factors.
            </h4>

            <Main
              setRefetch={setRefetch}
              refetch={refetch}
              setShowSuccessModal={setShowSuccessModal}
              setErr={setErr}
              setShowErrorModal={setShowErrorModal}
            />
          </div>
        </div>
      </div>
      {showAddTier && (
        <AddTierModal
          setShow={setShowAddTier}
          setShowErrorModal={setShowErrorModal}
          setErr={setErr}
          setRefetch={setRefetch}
          refetch={refetch}
          setShowSuccessModal={setShowSuccessModal}
        />
      )}
      {showErrorModal && (
        <ErrorModal show={showErrorModal} setShow={setShowErrorModal} />
      )}

      {showSuccessModal && (
        <SuccessModal
          setShow={setShowSuccessModal}
          message={err}
          route={"/Inventory/AddProduct/AddTier"}
        />
      )}
    </>
  );
};

export default Mid;
